/* VEX Premium (v19) — hero slider, header, search, look builder, product gallery */
(function () {
  'use strict';
  var D = document, W = window;
  var RM = matchMedia('(prefers-reduced-motion:reduce)').matches;
  function q(s, r) { return (r || D).querySelector(s); }
  function qa(s, r) { return [].slice.call((r || D).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (x) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[x]; }); }
  function egp(c) { return Math.round(c / 100).toLocaleString('en-US') + ' ج.م'; }

  /* ---------- Header: shadow after scroll ---------- */
  var H = q('[data-vxh2]');
  if (H) { var on = false, chk = function () { var n = scrollY > 40; if (n !== on) { on = n; H.classList.toggle('is-scrolled', n); } }; chk(); W.addEventListener('scroll', chk, { passive: true }); }

  /* ---------- Hero slider ---------- */
  qa('[data-vxhero]').forEach(function (R) {
    var S = qa('.vxhero__s', R), Dt = qa('[data-vxhero-to]', R), cur = 0, t = null, sp = (+R.getAttribute('data-speed') || 6) * 1000;
    if (S.length < 2) return;
    function go(i) {
      cur = (i + S.length) % S.length;
      S.forEach(function (s, k) { s.classList.toggle('is-on', k === cur); s.setAttribute('aria-hidden', k === cur ? 'false' : 'true'); var im = q('img', s); if (k === cur && im && im.loading === 'lazy') im.loading = 'eager'; });
      Dt.forEach(function (d, k) { d.classList.toggle('is-on', k === cur); });
    }
    function start() { clearInterval(t); if (!RM) t = setInterval(function () { if (!D.hidden) go(cur + 1); }, sp); }
    Dt.forEach(function (d) { d.addEventListener('click', function () { go(+d.getAttribute('data-vxhero-to')); start(); }); });
    var x0 = null;
    R.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    R.addEventListener('touchend', function (e) { if (x0 == null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 45) { go(cur + (dx < 0 ? -1 : 1)); start(); } x0 = null; }, { passive: true });
    start();
  });

  /* ---------- Search modal (client-side, Arabic-friendly) ---------- */
  var SM = q('#vxs2');
  function sOpen() { if (!SM) { location.href = '/search'; return; } SM.hidden = false; D.body.classList.add('vx-lock'); requestAnimationFrame(function () { SM.classList.add('is-on'); var i = q('[data-search-input]', SM); i && i.focus(); }); }
  function sClose() { if (!SM || SM.hidden) return; SM.classList.remove('is-on'); D.body.classList.remove('vx-lock'); setTimeout(function () { SM.hidden = true; }, 250); }
  D.addEventListener('click', function (e) {
    if (e.target.closest('[data-open-search]')) { e.preventDefault(); sOpen(); return; }
    if (e.target.closest('[data-close-search]')) { sClose(); }
  });
  D.addEventListener('keydown', function (e) { if (e.key === 'Escape') sClose(); });
  if (SM) {
    var inp = q('[data-search-input]', SM), out = q('[data-search-results]', SM), base = out.innerHTML, tm, ALL = null;
    var norm = function (t) { return String(t || '').toLowerCase().replace(/[ً-ْـ]/g, '').replace(/[أإآ]/g, 'ا').replace(/ى/g, 'ي').replace(/ة/g, 'ه'); };
    function load() {
      if (ALL) return Promise.resolve(ALL);
      try { var c = JSON.parse(sessionStorage.getItem('vxs2_cat') || 'null'); if (c && Date.now() - c.t < 6e5) { ALL = c.p; return Promise.resolve(ALL); } } catch (e) { }
      return fetch('/products.json?limit=250').then(function (r) { return r.json(); }).then(function (j) {
        ALL = (j.products || []).map(function (p) { var v = p.variants || []; return { t: p.title, h: p.handle, ty: p.product_type, tg: (p.tags || []).join(' '), i: p.images && p.images[0] ? p.images[0].src : '', pr: v.length ? +v[0].price : 0, av: v.some(function (x) { return x.available; }) }; });
        try { sessionStorage.setItem('vxs2_cat', JSON.stringify({ t: Date.now(), p: ALL })); } catch (e) { }
        return ALL;
      });
    }
    D.addEventListener('click', function (e) { if (e.target.closest('[data-open-search]')) load().catch(function () { }); });
    inp.addEventListener('input', function () {
      clearTimeout(tm); var v = inp.value.trim();
      if (!v) { out.innerHTML = base; return; }
      tm = setTimeout(function () {
        load().then(function (all) {
          var words = norm(v).split(/\s+/).filter(Boolean);
          var ps = all.filter(function (p) { var hay = norm(p.t + ' ' + p.ty + ' ' + p.tg + ' ' + p.h.replace(/-/g, ' ')); return words.every(function (w) { return hay.indexOf(w) > -1; }); })
            .sort(function (a, b) { return (b.av - a.av); }).slice(0, 6);
          out.innerHTML = ps.length ? '<div class="vxs2__list">' + ps.map(function (p) {
            var n = String(p.t).split(' — ');
            var img = p.i ? p.i + (p.i.indexOf('?') > -1 ? '&' : '?') + 'width=200' : '';
            return '<a class="vxs2__it" href="/products/' + esc(p.h) + '">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '<i></i>') + '<span><b>' + esc(n[0]) + '</b>' + (n[1] ? '<small dir="ltr">' + esc(n[1]) + '</small>' : '') + '<em>' + Math.round(p.pr).toLocaleString('en-US') + ' ج.م' + (p.av ? '' : ' · خلصت') + '</em></span></a>';
          }).join('') + '</div><a class="vxs2__all" href="/search?type=product&q=' + encodeURIComponent(v) + '">شوف كل النتايج ←</a>' : '<p class="vxs2__hint">مفيش قطع مطابقة لـ «' + esc(v) + '». جرّب كلمة تانية زي «تريكو» أو «سويت شيرت».</p>';
        }).catch(function () { });
      }, 160);
    });
  }

  /* ---------- "اختار طقم كامل" links ---------- */
  function openLook(scroll) {
    var d = q('#vexLookDisclosure'); if (!d) return false;
    d.open = true;
    if (scroll) setTimeout(function () { q('#look-builder').scrollIntoView({ behavior: RM ? 'auto' : 'smooth', block: 'start' }); }, 120);
    return true;
  }
  D.addEventListener('click', function (e) {
    var a = e.target.closest('[data-vxp-look]'); if (!a) return;
    if (q('#vexLookDisclosure')) { e.preventDefault(); D.body.classList.remove('vxo'); var n = q('#vxn'); n && n.setAttribute('aria-hidden', 'true'); openLook(true); }
  });
  if (location.hash === '#look-builder') setTimeout(function () { openLook(true); }, 300);

  /* ---------- Look builder ---------- */
  qa('[data-vxlook]').forEach(function (R) {
    var J; try { J = JSON.parse(q('[data-lk-data]', R).textContent); } catch (e) { return; }
    var cur = { top: null, bottom: null };
    ['top', 'bottom'].forEach(function (k) { var b = q('[data-lk-pick="' + k + '"].is-on', R) || q('[data-lk-pick="' + k + '"]', R); cur[k] = b && b.getAttribute('data-handle'); });
    function sizes(k) {
      var s = q('[data-lk-size="' + k + '"]', R), p = J[cur[k]], prev = s.value; if (!p) return;
      s.innerHTML = '<option value="">اختار المقاس</option>' + p.v.map(function (v) { return '<option value="' + v[0] + '"' + (v[2] ? '' : ' disabled') + '>' + esc(v[1]) + (v[2] ? '' : ' — خلص') + '</option>'; }).join('');
      if (prev && q('option[value="' + prev + '"]', s)) s.value = prev;
    }
    function paint() {
      var t = J[cur.top], b = J[cur.bottom]; if (!t || !b) return;
      var it = q('[data-lk-img="top"]', R), ib = q('[data-lk-img="bottom"]', R);
      it.src = t.i; it.alt = t.n; ib.src = b.i; ib.alt = b.n;
      q('[data-lk-names]', R).textContent = t.n + ' × ' + b.n;
      q('[data-lk-total]', R).textContent = egp(t.p + b.p);
      qa('[data-lk-pick]', R).forEach(function (x) { var k = x.getAttribute('data-lk-pick'), o = x.getAttribute('data-handle') === cur[k]; x.classList.toggle('is-on', o); x.setAttribute('aria-pressed', o ? 'true' : 'false'); });
      sizes('top'); sizes('bottom');
    }
    R.addEventListener('click', function (e) {
      var p = e.target.closest('[data-lk-pick]');
      if (p) { cur[p.getAttribute('data-lk-pick')] = p.getAttribute('data-handle'); q('[data-lk-size="' + p.getAttribute('data-lk-pick') + '"]', R).value = ''; paint(); return; }
      var a = e.target.closest('[data-lk-scroll]');
      if (a) { var st = q('[data-lk-strip="' + a.getAttribute('data-lk-scroll') + '"]', R); st && st.scrollBy({ left: +a.getAttribute('data-dir') * 240, behavior: 'smooth' }); return; }
      var go = e.target.closest('[data-lk-add]');
      if (go) {
        var st2 = q('[data-lk-size="top"]', R), sb = q('[data-lk-size="bottom"]', R), er = q('[data-lk-err]', R);
        st2.classList.toggle('err', !st2.value); sb.classList.toggle('err', !sb.value);
        if (!st2.value || !sb.value) { er.textContent = 'اختار مقاس القطعة العلوية ومقاس البنطلون'; er.hidden = false; return; }
        er.hidden = true; go.disabled = true; var txt = go.textContent; go.textContent = 'بنجهّز طقمك…';
        var t = J[cur.top], b = J[cur.bottom];
        var add = W.vxAdd ? W.vxAdd([{ id: +st2.value, quantity: 1 }, { id: +sb.value, quantity: 1 }]) : Promise.reject(new Error('x'));
        add.then(function () {
          try { sessionStorage.setItem('vxlook', JSON.stringify({ t: 'Your Look', i: [t.i, b.i], n: [t.n, b.n] })); } catch (x) { }
          go.disabled = false; go.textContent = txt; W.vxCartOpen && W.vxCartOpen(true); W.vxRefreshCart && W.vxRefreshCart();
        }).catch(function (x) { go.disabled = false; go.textContent = txt; er.textContent = (x && x.message && x.message !== 'x') ? x.message : 'حصلت مشكلة، جرّب تاني'; er.hidden = false; });
      }
    });
    paint();
  });

  /* ---------- Product gallery (slider with dots / arrows / counter) ---------- */
  var T = q('[data-vpd-track]');
  if (T) {
    var sl = qa('.vpd__s', T), N = sl.length, dots = qa('[data-vpd-to]'), cnt = q('[data-vpd-cnt]');
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var idx = function () { return Math.max(0, Math.min(N - 1, Math.round(Math.abs(T.scrollLeft) / Math.max(1, T.clientWidth)))); };
    var upd = function () { var i = idx(); dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); }); if (cnt) cnt.textContent = pad(i + 1) + ' / ' + pad(N); };
    var to = function (i) { i = (i + N) % N; var s = sl[i]; if (!s) return; var tr = T.getBoundingClientRect(), sr = s.getBoundingClientRect(); T.scrollBy({ left: sr.left - tr.left, behavior: RM ? 'auto' : 'smooth' }); setTimeout(upd, 450); };
    T.addEventListener('scroll', function () { clearTimeout(T._t); T._t = setTimeout(upd, 60); }, { passive: true });
    dots.forEach(function (d) { d.addEventListener('click', function () { to(+d.getAttribute('data-vpd-to')); }); });
    qa('[data-vpd-step]').forEach(function (b) { b.addEventListener('click', function () { to(idx() + (+b.getAttribute('data-vpd-step'))); }); });
    D.addEventListener('click', function (e) {
      if (!e.target.closest('.vpd .button_variation')) return;
      setTimeout(function () { try { var P = JSON.parse(q('[data-product-json]').textContent), id = +q('[data-variant-input]').value, v = P.variants.filter(function (x) { return x.id === id; })[0]; if (v && v.media) { var k = sl.map(function (s) { return +s.getAttribute('data-media-id'); }).indexOf(v.media); if (k > -1) to(k); } } catch (x) { } }, 50);
    });
  }

  /* ---------- Size buttons: primary button text ---------- */
  qa('.vpd').forEach(function (R) {
    var add = q('[data-add]', R);
    if (!add) return;
    var hasOpts = qa('.vx-opt', R).length > 0;
    function wait() { if (hasOpts && !qa('.button_variation.on', R).length && !add.disabled) { add.classList.add('is-wait'); add.textContent = 'اختار المقاس الأول'; } }
    wait(); setTimeout(wait, 400); setTimeout(wait, 1200);
    R.addEventListener('click', function (e) {
      if (!e.target.closest('.button_variation')) return;
      setTimeout(function () { add.classList.remove('is-wait'); if (!add.disabled) { var pr = q('.vpd__price [data-price]', R); add.textContent = 'أضف للسلة' + (pr ? ' — ' + pr.textContent.trim() : ''); } }, 30);
    });
  });

  /* ---------- Reviews fallback (until Judge.me shows reviews) ---------- */
  var RV = q('[data-vpd-reviews]');
  if (RV) setTimeout(function () {
    var w = q('#judgeme_product_reviews', RV), fb = q('[data-vpd-rev-fb]', RV);
    var has = w && w.querySelector('.jdgm-rev');
    if (!has && fb) { fb.hidden = false; if (w && !w.textContent.trim()) w.hidden = true; }
  }, 2500);
})();
